import { Select } from "melco-ui";
import { useTranslation } from "react-i18next";

import { useGetRoles } from "../../hooks/roles/useGetRoles";


type RolesListProps = {
  onChange: (value: string) => void;
  value?: string;
};

export const RolesSelect: React.FC<RolesListProps> = ({
  value,
  onChange,
}) => {
 
const { t } = useTranslation();
const { data } = useGetRoles();

  const roleList:any = (data)?.list.map(
    (role) => ({
      value: role.code,
      label:  role.name,
      id: role.id
    })
  );


  
  const roleListOptions: any = roleList;

  return (
    <Select
    
      allowClear
      placeholder={t('common.role')}
      style={{ width: "100%",}}
      maxTagCount={1}
      options={roleListOptions}
      onChange={onChange}
      value={  value}
    />
  
  );
};
